import { useParams } from 'react-router-dom';
import { AdminLockGate } from '../../components/lock/AdminLockGate.js';
import { SettingsPage } from './SettingsPage.js';
import { isAdminLockedGroup } from './adminLockedGroups.js';

/**
 * `/settings/g/:group`, with the keypad in front of THREE of the groups.
 *
 * The gate used to wrap this route unconditionally, which is what put a
 * full-screen PIN pad in front of the leave calendar. It cannot be decided in
 * `App.tsx` because the group is a route PARAM, and a param needs a component
 * inside the route to read it — so this is that component and nothing else.
 *
 * The search box is the other half of the same rule and lives in `SettingsPage`:
 * a group gated here must not be readable from a search run on an open group.
 */
export function SettingsGroupRoute(): JSX.Element {
  const { group } = useParams<{ group?: string }>();
  if (!isAdminLockedGroup(group)) return <SettingsPage />;
  return (
    <AdminLockGate>
      <SettingsPage />
    </AdminLockGate>
  );
}
